
export default {
  roomList: {
    '&:not(:first-of-type)': {
      '&:before': {
        content: "''",
        display: 'block',
        borderTop: '1px solid #d8d8d8',
        margin: '20px auto 30px',
        maxWidth: '1170px'
      }
    }
  },
  hasLoyaltyUser: {},
  ftTabBck:{
    background: '#E0E0E0',    
  },
  starTabBackground:{},
  starOfferContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',    
    color: '#847648',
    '&$ftTabBck':{
      color: '#4F5D70',
    },
    '&$starTabBackground': {
      background: '#F0EFE9',
    },
    '& div': {
      color: data => data.mainColor,
      font: '14px "Roboto", sans-serif',
      '@media(max-width:601px)':{
        fontSize: '12px',
      },
    },
  },
  stOffer:{},
  offerDiscount: {  
    font: 'Bold 29px "Roboto", sans-serif',
    '&$stOffer':{
      borderRight: '1px solid #847648',
      paddingRight: '11px',
    },    
    '@media(max-width:601px)':{      
      display: 'none',
    },
  },
  starDefaultPrice: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    color: '#000',
    font: '400 12px "Roboto", sans-serif',
    '&$starTabBackground': {
      background: '#E5E5E5',
    },
    '&$ftTabBck':{
      color: '#4F5D70',
    },
    '& $starOfferTitle': {
      fontWeight: '600'
    },
    '@media(min-width:601px)':{
      fontSize: '14px', 
    }
  },
  selectedStarTab:{
    '& $ftTabBck':{
      background: 'transparent linear-gradient(180deg, #909AAA 0%, #909AAA 100%) 0% 0% no-repeat padding-box',
      color: '#FFF',
      '&$hasLoyaltyUser':{
        background: '#FFF',
        color: '#4F5D70'
      }
    },
    '& $starOfferContainer': {
      '&$starTabBackground': {
        background: '#fff',
        borderTop: '4px solid #847648',      
      },
    },
    '& $starDefaultPrice': {
      '&$starTabBackground': {
        background: '#fff',
      },
    },
  },
  starOfferTitle: {},
  standarPriceLink:{},
  ftNoInterest:{},
  ButtonNoInterest: {
    marginTop: '10px',
    font: '600 14px "Roboto", sans-serif',
    color: '#857550',
    textDecoration: 'underline',
    '&$ftNoInterest': {
      color: '#FFF',
    }
  },
  starOfferDescription: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginLeft: '10px',
    '& $starOfferTitle': {
      fontWeight: '600'
    }
  },
  ftTabDesc:{
    textAlign: 'left',
    marginLeft: '15px'
  },
  starTabTitle:{
    display:'block',
    font: '600 14px "Roboto", sans-serif',
  },
  ftSubTitle:{},
  starTabSubTitle:{
    font: '14px "Roboto", sans-serif',
    '&$ftSubTitle':{
      color: '#FFF',
      marginLeft: '20px',
    },
  },
  starTabLogged: {
    background: '#7E899A',
    opacity: '0.6',
    '& span':{
      color: '#fff',
    }
  },
  starTabsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    maxWidth: '1170px',
    background: '#E5E5E5',
    marginTop: '10px!important',
    textAlign: 'center',
    '& li':{
      flex: '50%',
      '& button':{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        '&:before':{
          content: 'none'
        },
        '& > div':{
          padding: '10px 5px',
          width: '100%',
          minHeight: '35px',
        },
      },
    },
    '@media(min-width:601px)':{
      padding: '15px 0',
      margin: '0 auto!important',
      marginTop: '20px!important',
    },
    '@media(max-width:800px)': {
      margin: '0 10px!important',
      marginTop: '5px!important',
    },
    '@media(min-width:801px) and (max-width:1200px)': {
      margin: '0 20px!important',
      marginTop: '20px!important',
    }
  },
  starCheckText: {
    font: '14px "Roboto", sans-serif',
    color: '#847648',
  },
  starCheckContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    maxWidth: '1170px',
    background: '#FFF',
    marginTop: '10px!important',
    textAlign: 'center',
    gap: '10px',
    boxSizing: 'border-box',
    '@media(min-width:601px)':{
      padding: '15px',
      margin: '0 auto!important',
      marginTop: '20px!important',
    },
    '@media(max-width:800px)': {
      margin: '20px 10px',
      padding: '15px',
      justifyContent: 'center',
      
    },
    '@media(min-width:801px) and (max-width:1200px)': {
      margin: '0 20px!important',
      marginTop: '20px!important',
    },
    '& $starLogoSvg': {
      maxWidth: '200px',
      '@media(max-width:800px)': {
        maxWidth: '150px',
      },
      '& $starTravelerTabLogo':{
        width: '90%',
        fill: '#c94',
        /* '@media(max-width:800px)': {
          width: '70%',
        }, */
      },
    },
  },
  starTravelerTabLogo:{},
  starLogoSvg:{},
  fidelTourTab:{},
  estandarTab:{},
  containerRateStarTraveler: {
    backgroundColor: '#F3F2EF',
    margin: '0 0 15px 0',
    '@media(min-width:801px)': {
      margin: '0 0 35px 0',
    },
  },
  containerRateFidelTour: {
    backgroundColor: '#eaf6ff',
    '& $rateBox': {
      height: '66px',
      '@media(min-width:801px)': {
        height: '100px',
      }
    },
  },
  startTraveler: {},
  fidelTour: {},
  rateBox: {
    maxWidth: '1170px',
    display: 'flex',
    paddingLeft: '10px',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 10px',
    height: '60px',

    '@media(min-width:801px)': {
      //margin: '20px auto -20px auto',
      //padding: '0 20px',
      //paddingTop: '10px',
      margin: '0 auto',
      padding: '0',
      justifyContent: 'flex-end',
      height: '80px',
    },

    '& svg': {
      width: '120px',
      '@media(min-width:801px)': {
        width: '180px',
        marginRight: '10px',
      },
    },
    '& span': {
      color: '#857550',
      fontWeight: '300',
      font: "14px 'Roboto',sans-serif",
      textAlign: 'right',
      '@media(min-width:801px)': {
        fontSize: '18px',
      },

      '& > span': {
        width: 'fit-content',
      }
    },
  },
  buttonLogo: {
    outline: 'none',
    border: 'none',
    cursor: 'pointer',
  },
  toggleCheck: {
    display: 'flex',
    alignItems: 'center',
    '@media(min-width:801px)': {
      padding: '0 0 0 10px'
    },
  },
  loyaltyText: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    '@media(min-width:801px)': {
      padding: '0 0 0 10px'
    },
  },
  loyaltyLoginButton: {
    fontWeight: '500 !important',
    font: "12px 'Roboto',sans-serif !important",
    textDecoration: 'underline !important',
  },
  switch: {
    position: 'relative',
    //display: 'inline-block',
    width: '55px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    cursor: 'pointer',
    '@media(max-width:600px)': {
      paddingRight: '10px',
    },
    '@media(min-width:801px)': {
      width: '75px',
      height: '45px',
      marginRight: '5px',
    },

    '@media(min-width:901px)': {
      width: '62px',
      height: '45px',
      marginRight: '0px',
    },

    '@media(min-width:901px) and (max-width:1200px)': {
      marginRight: '25px',
    },

    '& label': {
      position: 'relative',
      display: 'inline-block',
      height: '22px',
      left: '5px',
 
      '@media(min-width:801px)': {
        height: '25px',
        width: '34px',
        left: '10px',
        paddingLeft: '25px',
      },
      '@media(max-width:425px)': {
        width: '25px',
      },
      '@media(min-width:394px) and (max-width:409px)': {
        width: '42px',
      },
 
      '@media(min-width:410px) and (max-width:425px)': {
        width: '39px',
      },
      '&:before':{
        display:'none',
      }
    },
    '& span':{
      width:'35px',
      '&:before':{
        transform: 'translateX(13px)',
      },

      '@media(min-width:801px)': {
        width:'46px',
        height: '24px',
        '&:before':{
          transform: 'translateX(19px)',
        },
      }
    },
  },
  //widthFideltour: {
    //width: '65px',
  //},
  switchInput: {
    opacity: '0',
    width: '0',
    height: '0',
    
    '&:checked + $slider:before': {
      transform: 'translateX(14px)',
      backgroundColor: '#847647',

      '@media(min-width:801px)': {
        transform: 'translateX(19px)',
      },
    },
    '&:not(:checked) + $slider:before': {
      opacity: '20%',
    },
  },
  slider: {
    position: 'absolute',
    cursor: 'pointer',
    top: '0',
    left: '4px',
    right: '0',
    bottom: '0',
    backgroundColor: '#fff',
    transition: '0.4s',
    '&:before': {
      position: 'absolute',
      content: '""',
      height: '16px',
      width: '16px',
      left: '3px',
      bottom: '2px',
      backgroundColor: 'white',
      transition: '0.4s',

      '@media(min-width:801px)': {
        height: '19px',
        width: '19px',
        left: '4px',
        bottom: '3px',
      },
    },
  },
  sliderChecked: {
    backgroundColor: '#ccc',
  },
  sliderRound: {
    borderRadius: '34px',
    border: '1px solid #847648',
    '&:before': {
      borderRadius: '50%',
      backgroundColor: '#847648',
    },
  },
  disabled: {
    opacity: 0.3,
    pointerEvents: 'none',
  },
  starTab:{
    maxWidth: '1170px',
    margin: '0 auto',
    marginTop: '20px',
    padding: '15px',
    background: '#FFF',
    minHeight: '70px',
    maxHeight: '110px',
    '& > div': {
      width: '100%',
      marginLeft: '20px',
      '@media(max-width:800px)': {
        marginLeft: '7px',
      },
    },
    '&$fidelTourTab':{
      maxHeight: 'none',      
      '@media(min-width:801px)': {        
        maxHeight: '70px',
        padding: '20px 0',
      },
      '&$estandarTab': {        
        '@media(min-width:801px)': {        
          maxHeight: '70px',
          padding: '0',
        },
      },
      background: 'transparent linear-gradient(180deg, #909AAA 0%, #4E5C6F 100%) 0% 0% no-repeat padding-box',      
      '& > div': {
        margin: '0' ,
        '@media(min-width:801px)': {
          padding: '0',          
          margin: '0'          
        },
      },
    },
    '&$estandarTab': {
      '@media(min-width:601px)':{
        padding: '10px 0',
      }
    },
    '@media(min-width:601px)':{
      padding: '0',
      margin: '0 auto',
      display: 'flex',
      alignItems: 'center',      
    },    
    '@media(max-width:800px)': {
      margin: '0 10px',
      marginBottom: '15px',
      display: 'flex',
      alignItems: 'center',
    },
    '@media(min-width:801px) and (max-width:1200px)': {
      margin: '0 20px',
    },
    '@media(min-width:801px)': {
      maxHeight: '70px'
    },
    '&.hasLoyaltyUser': {
      background: 'white',
      /* '& > div': {
        ' & > div': {
          '& > div': {
            padding: '0'
          }
        }
      }, */
    },
    '& $starLogoSvg': {
      maxWidth: '200px',
      marginLeft: '30px',
      '@media(max-width:800px)': {
        marginLeft: '0',
        maxWidth: '100px',
      },
      '& $starTravelerTabLogo':{
        width: '100%',
        fill: '#c94',
        '@media(max-width:800px)': {
          width: '70%',
        },
      },
    },
    '&.no-padding': {
      padding: '0'
    },
    '& + ul':{
      '& > li':{
        '& > div':{
          '& > ul':{
            paddingTop: '0!important',
          }
        }
      }
    }
  },
  listHabi: {},
  listContainer: {},
  isLoyalty: {
    '& > li':{
      '& $defaultStyle': {
        paddingTop: '0'
      }
    }
  },
  calendarInfoButton:{},
  wiCalendarInfoButton:{},
  seeHotelWeb:{},
  destinationAvailBox:{},
  footer: {
    marginTop: 'auto',
  },
  defaultStyle: {
    minHeight:'calc(100vh)',
    display:'flex',
    flexDirection:'column',
    justifyContent: 'center',
    flexWrap:'wrap',
    '@media(min-width:901px)':{
      minHeight:'calc(100vh - 62px)',
    },
    '& $listContainer': {
      listStyle: 'none',
      padding: '0 20px 100px',
      marginTop: '30px',
      '@media(max-width:800px)': {
        padding: '5px 10px 130px',
        marginTop: '15px',
      }
    },
    '& $listHabi': {
      padding: '0 10px 10px',
      background: '#f1f1f1',
      '& > li': {
        maxWidth: '1180px',
        margin: '0 auto 30px',
      }
    },
    '& $calendarInfoButton': {
      display:'flex',
      flexWrap:'nowrap',
      alignItems:'stretch',
      justifyContent:'space-between',
      gap: '10px',
      padding:'10px',
      '& div': {
        alignItems: 'center',
        display: 'flex',
        '& span': {
          display: 'flex',
          alignItems: 'center',
        }
      },
      '& $seeHotelWeb':{
        border: '1px solid #d8d8d8',
        borderRadius: '30px',
        textAlign:'center',
        '& span':{
          '& span':{
            right:'0',
            '&:lang(ar)':{
              right: 'auto',
              left: '0',
              transform: 'rotate(180deg)',
            }
          }
        },
        '& button':{
          width:'auto',
          maxWidth:'200px',
          alignItems: 'center',
          padding: '5px 10px',
          cursor: 'pointer',
          '&:lang(ar)':{
            paddingRight: '0',
          }
        }
      },
      '& $destinationAvailBox':{
        border: '1px solid #d8d8d8',
        borderRadius: '30px',
        textAlign:'center',
        '& span':{
          '& span':{
            right:'0',
            '&:lang(ar)':{
              right: 'auto',
              left: '0',
              transform: 'rotate(180deg)',
            }
          }
        },
        '& button':{
          width:'auto',
          maxWidth:'200px',
          alignItems: 'center',
          padding: '5px 10px',
          cursor: 'pointer',
          '&:lang(ar)':{
            paddingRight: '0',
          },
          '& span': {
            textAlign: 'left',
            '@media (max-width:800px)': {
              textAlign: 'center',
            },
            '&  div > div > svg': {
              width: '15px',
            }
          }
        }
      },
      '&:lang(ar)':{
        flexDirection: 'row-reverse',
      }
    },
    '& $wiCalendarInfoButton': {
      padding: '5px 10px',
    },
  },
  nocheck:{
    '&:before':{
      opacity: '30%',
      transform: 'translateX(0px) !important',
    },
    opacity: '50%',
  },
  rateTooltip: {
    textAlign: 'center',
    position: 'absolute',
    maxWidth: '250px',
    display: 'table',
    backgroundColor: '#fc0',
    font: "11px 'Roboto',sans-serif",
    color: '#333',
    padding: '20px 15px',
    zIndex: '700',
    '@media (max-width:600px)': {
      paddingTop: '25px',
    }
  },
  ratePopover: {
    height: '10%',
    width: '10%'
  },
  tooltipPointerStyle: {
    zIndex: '700',
    backgroundColor: '#fc0',
    width: '10px',
    height: '10px'
  },
  toolTipFideltour: {
    zIndex: '0',
    paddingLeft: '5px',
    position: 'relative',
    top: '2px',
    cursor: 'pointer',

    '@media (min-width:801px)': {
      paddingLeft: '10px',
      paddingRight: '15px',
      top: '3px',
    }
  },
};
